import React from 'react';
import { translate } from 'react-i18next';
import { Card, Input, Checkbox, TextArea, Icon, Button, Modal, Dropdown } from 'semantic-ui-react';

import Utils from 'utils/Utils.js';
import {colors, buttons, spacings, shadow, fonts} from 'style';
import LogCard from './LogCard.js';
import ChoosePhotoContainer from 'modules/misc/ChoosePhotoContainer.js';
import ChallengeQuestionPhotoContainer from './ChallengeQuestionPhotoContainer.js';
import ChallengeQuestionDateContainer from './ChallengeQuestionDateContainer.js';
import ChallengeQuestionDateTimeContainer from './ChallengeQuestionDateTimeContainer.js';
import Portal from 'modules/misc/Portal.js';
import UserChallengeComplete from 'modules/challenges/UserChallengeComplete.js';

var style = {
    modal: {
        textAlign: 'left',
    },
    logCard: {
        maxWidth: '992px',
    },
    content: {
        overflow: 'auto',
        borderTop: '1px solid ' + colors.themeDarkGrey,
        padding: spacings.small,
        textAlign: 'center',
    },
    categoryButton: {
        position: 'relative',
        backgroundColor: '#fff',
        marginLeft: spacings.tiny,
        marginRight: spacings.tiny,
        display: 'inline-block',
        height: '60px',
        minWidth: '200px',
        cursor: 'pointer',
        boxShadow: shadow,
        paddingLeft: '48px',
        paddingRight: spacings.small,
        border: '1px solid ' + colors.themeDarkGrey,
        borderRadius: spacings.tiny,
        color: colors.themeDarkGrey,
        ...fonts.body,
    },
    categoryBadge: {
        position: 'absolute',
        left: spacings.small,
        top: spacings.small,
        height: '28px',
        width: '28px',
    },
    dropdownContainer: {
        textAlign: 'right',
        padding: spacings.tiny,
        color: colors.themeDarkerGrey,
    },
    dropdown: {
        textAlign: 'left',
        width: '384px',
    },
    inputWrapper: {
        color: colors.themeDarkerGrey,
        position: 'relative',
        padding: spacings.tiny,
    },
    inputLabel: {
        display: 'block',
        textAlign: 'left',
        paddingRight: spacings.tiny,
        paddingBottom: '4px',
    },
    booleanInputLabel: {
        position: 'relative',
        textAlign: 'left',
        paddingLeft: spacings.tiny,
        bottom: '4px',
    },
    units: {
        float: 'right',
    },
    input: {
        width: '384px',
        textAlign: 'left',
    },
    textArea: {
        borderRadius: '4px',
        border: '1px solid rgba(34, 36, 38, 0.15)',
    },
    submitButtonBar: {
        width: '100%',
        padding: spacings.base,
        borderTop: '1px solid ' + colors.themeDarkGrey,
        textAlign: 'right',
    },
    submitButton: {
        ...buttons.long,
        backgroundColor: colors.themeTeal,
    },
    questionContainer: {
        textAlign: 'left',
        width: '400px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    photoContainer: {
        display: 'inline-block',
        width: '400px',
        verticalAlign: 'top',
        marginRight: spacings.base,
    },
    pointsIcon: {
        color: colors.pointsYellow,
    },
    pointsRow: {
        textAlign: 'left',
        color: colors.pointsYellow,
    },
    pointsWrapper: {
        paddingTop: spacings.tiny,
        paddingBottom: spacings.tiny,
    },
    pointsEarned: {
        textAlign: 'left',
        color: colors.themeDarkerGrey,
    },
    pointValues: {
        float : 'right',
    },
    popup:{
        width: '100%',
        height: '100%',
        position: 'fixed',
        top: '0',
        left:'0',
        zIndex: '2000',
        backgroundColor:'#fff',
    },
};


const ChallengeQuestionString = ({challengeQuestion, index, onChange}) => (
    <div style={style.inputWrapper}>
        <label style={style.inputLabel}>{challengeQuestion.label}{Boolean(challengeQuestion.optional) ? ' (Optional)' : ''}</label>
        <Input name={'selectedChallenge.challengeQuestions.' + index + '.data'} 
               value={challengeQuestion.data || ''}
               onChange={onChange}
               style={style.input} />
    </div>
);

const ChallengeQuestionTextArea = ({t, challengeQuestion, index, onChange}) => (
    <div style={style.inputWrapper}>
        <label style={style.inputLabel}>{challengeQuestion.label}{Boolean(challengeQuestion.optional) ? ' (Optional)' : ''}</label>
        <TextArea name={'selectedChallenge.challengeQuestions.' + index + '.data'} 
               value={challengeQuestion.data || ''}
               onChange={onChange}
               placeholder = {t('log_activity_note_hint')}
               autoHeight
               style={{...style.input, ...style.textArea}} />
    </div>
);

const ChallengeQuestionInteger = ({challengeQuestion, index, onChangeNumber}) => (
    <div style={style.inputWrapper}>
        <label style={style.inputLabel}>{challengeQuestion.label}{Boolean(challengeQuestion.optional) ? ' (Optional)' : ''}</label>
        <Input name={'selectedChallenge.challengeQuestions.' + index + '.data'} 
               value={challengeQuestion.data || ''}
               onChange={onChangeNumber}
               style={style.input} type="number" />
    </div>
);

const ChallengeQuestionIntegerMinutes = ({t, challengeQuestion, index, onChangeNumber, onBlur}) => (
    <div style={style.inputWrapper}>
        <label style={style.inputLabel}>{challengeQuestion.label}{Boolean(challengeQuestion.optional) ? ' (Optional)' : ''}<span style={style.units}>{t('minutes')}</span></label>
        <Input name={'selectedChallenge.challengeQuestions.' + index + '.data'} 
               value={challengeQuestion.data || ''}
               onChange={onChangeNumber}
               onBlur={onBlur}
               style={style.input} type="number" />
    </div>
);

const ChallengeQuestionIntegerCalories = ({t, challengeQuestion, index, onChangeNumber}) => (
    <div style={style.inputWrapper}>
        <label style={style.inputLabel}>{challengeQuestion.label}{Boolean(challengeQuestion.optional) ? ' (Optional)' : ''}<span style={style.units}>{t('calories')}</span></label>
        <Input name={'selectedChallenge.challengeQuestions.' + index + '.data'} 
               value={challengeQuestion.data || ''}
               onChange={onChangeNumber}
               style={style.input} type="number" />
    </div>
);

const ChallengeQuestionFloat = ({challengeQuestion, index, onChangeNumber}) => (
    <div style={style.inputWrapper}>
        <label style={style.inputLabel}>{challengeQuestion.label}{Boolean(challengeQuestion.optional) ? ' (Optional)' : ''}</label>
        <Input name={'selectedChallenge.challengeQuestions.' + index + '.data'} 
               value={challengeQuestion.data || ''}
               onChange={onChangeNumber}
               style={style.input} type="number" />
    </div>
);

const ChallengeQuestionBoolean = ({challengeQuestion, index, onToggle, inline}) => (
    <div style={{...style.inputWrapper, ...(inline && {display:'inline-block', float: 'left'})}}>
        <Checkbox name={'selectedChallenge.challengeQuestions.' + index + '.data'} 
                  onChange={onToggle}
                  checked={Boolean(challengeQuestion.data)}/>
        <label style={style.booleanInputLabel}>{challengeQuestion.label}{Boolean(challengeQuestion.optional) ? ' (Optional)' : ''}</label>
    </div>
);

const ChallengeQuestionLabel = ({challengeQuestion}) => (
    <div style={style.inputWrapper}>
        <label style={style.inputLabel}>{challengeQuestion.label}{Boolean(challengeQuestion.optional) ? ' (Optional)' : ''}</label>
    </div>
);




const ChallengeQuestionComponent = (props) => {
    switch (props.challengeQuestion.dataType) {
        case 0:   return <ChallengeQuestionString  {...props} />;
        case 1:   return <ChallengeQuestionInteger {...props} />;
        case 2:   return <ChallengeQuestionDateTimeContainer  {...props} />; //Date + Time
        case 3:   return <ChallengeQuestionBoolean {...props} />; //Boolean
        case 4:   return <ChallengeQuestionFloat  {...props} />; //Float
        case 5:   return <ChallengeQuestionTextArea  {...props} />; //Text Area
        case 6:   return null; //Photo
        case 7:   return <ChallengeQuestionLabel   {...props} />; //Label
        case 100: return <ChallengeQuestionIntegerMinutes  {...props} />; //Integer (minutes)
        case 101: return <ChallengeQuestionIntegerCalories  {...props} />; //Integer (calories)
        case 102: return <ChallengeQuestionDateContainer  {...props} />; //Birthdate
        case 105: return <ChallengeQuestionTextArea  {...props} />; //Text Area
        case 106: return <ChallengeQuestionBoolean {...props} />; //Boolean
        case 107: return <ChallengeQuestionDateTimeContainer  {...props} />; //Date + Time
        default: return <ChallengeQuestionString  {...props} />;
    }
};



const LogCardModal = ({t,
                  avatarUrl,
                  open,
                  categories,
                  hasPhotos,
                  saving,
                  saved,
                  valid,
                  pointsEarned,
                  selectedCategory,
                  selectedChallenge,
                  inputText,
                  modalContentMaxHeight,
                  uploadPhotoProps,
                  onUploadPhoto,
                  onConfirmPhoto,
                  onLaunch, 
                  onClose,
                  onContinue,
                  onChange,
                  onChangeNumber,
                  onBlur,
                  onChangeDateTime,
                  onToggle,
                  onSubmit,
                  onSelectCategory,
                  onSelectChallenge,
                  onCancelPhoto,
                  ...props}) => (
        <Modal style={style.modal}
            closeIcon
            open={open}
            onClose={onClose}>
            <LogCard 
                style={style.logCard}
                avatarUrl={avatarUrl}
                open={open}
                hide={false}
                saved={saved}
                categories={categories}
                selectedCategory={selectedCategory}
                inputText={inputText}
                onLaunch={onLaunch} 
                onContinue={onContinue}
                onSelectCategory={onSelectCategory} 
                onChange={onChange}>
                {!saved &&
                <div>
                    <div style={{...style.content, ...(modalContentMaxHeight && {maxHeight: modalContentMaxHeight}), ...(selectedCategory && {minHeight: '300px'})}}>
                        {selectedCategory===null && categories.map(category => 
                            <button className='noFocusHighlight' 
                                 onClick={()=>onSelectCategory(category)}
                                 style={style.categoryButton} 
                                 key={category.id}>
                                {category.badge &&
                                    <img style={style.categoryBadge} alt='' src={category.badge.url}></img>
                                }
                                {category.title}
                            </button>
                        )}
                        {selectedCategory &&
                            <div>
                                {hasPhotos &&
                                    <div style={style.photoContainer}>
                                        {selectedChallenge.challengeQuestions.map((challengeQuestion,i) => 
                                            <ChallengeQuestionPhotoContainer key={challengeQuestion.id} 
                                                                        challengeQuestion={challengeQuestion} 
                                                                        index={i}
                                                                        onUploadPhoto={onUploadPhoto}
                                                                        onChange={onChange}
                                                                        onToggle={onToggle}
                                                                        onCancelPhoto = {onCancelPhoto}/>
                                        )}
                                    </div>
                                }
                                <div style={{...style.questionContainer, ...(hasPhotos && {display:'inline-block'})}}>
                                    {Boolean(selectedCategory.challenges && selectedCategory.challenges.length > 1) &&
                                        <div style={style.dropdownContainer}>
                                            <Dropdown style={style.dropdown}
                                                options={selectedCategory.challenges.map(challenge => ({key:challenge.id , text: challenge.title, value:challenge.id}))} 
                                                selection
                                                closeOnChange
                                                value={selectedChallenge ? selectedChallenge.id : null}
                                                onChange={onSelectChallenge}
                                            />
                                        </div>
                                    }
                                    {Boolean(selectedChallenge && selectedChallenge.challengeQuestions) && 
                                        selectedChallenge.challengeQuestions.map((challengeQuestion,i) => 
                                            challengeQuestion.key!=='privacy' &&
                                                <ChallengeQuestionComponent key={challengeQuestion.id}
                                                    selectedCategory={selectedCategory}
                                                    challengeQuestion={challengeQuestion} 
                                                    t={t}
                                                    index={i}
                                                    onChange={onChange}
                                                    onChangeNumber={onChangeNumber}
                                                    onBlur={onBlur}
                                                    onChangeDateTime={onChangeDateTime}
                                                    onToggle={onToggle}/>
                                        )
                                    }
                                    {Boolean(selectedChallenge) && 
                                        <div style={style.pointsRow}>
                                            <hr />
                                            <div style={style.pointsWrapper}>
                                            <span style={style.pointsEarned}>{t('points-earned')}</span>
                                            <span style={style.pointValues}>
                                                <Icon style={style.pointsIcon} className="notClickable icon-star"/>
                                                {pointsEarned} 
                                            </span>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                    {selectedCategory &&
                        <div style={style.submitButtonBar}>
                            {Boolean(selectedChallenge && selectedChallenge.challengeQuestions) && 
                                selectedChallenge.challengeQuestions.map((challengeQuestion,i) => 
                                    challengeQuestion.key==='privacy' && 
                                        <ChallengeQuestionBoolean key={challengeQuestion.id}
                                                selectedCategory={selectedCategory}
                                                challengeQuestion={challengeQuestion} 
                                                t={t}
                                                index={i}
                                                inline
                                                onChange={onChange}
                                                onChangeDateTime={onChangeDateTime}
                                                onToggle={onToggle}/>
                                )
                            }
                            <Button style={style.submitButton} disabled={!valid} onClick={onSubmit}>{t('Add to Log')}</Button>
                        </div>
                    }

                    {Boolean(uploadPhotoProps) &&
                        <ChoosePhotoContainer onConfirmPhoto={photo=>onConfirmPhoto(uploadPhotoProps.field, photo)}
                                              width={uploadPhotoProps.width}
                                              height={uploadPhotoProps.height}
                                              file={uploadPhotoProps.file}
                                              onClose={onUploadPhoto}/>
                    }


                </div>
                }
            </LogCard>
            {saved &&
            <Portal>
                <div style={style.popup}>
                    <UserChallengeComplete progress={saved.progress}  onContinue={onContinue}  />
                </div>
            </Portal>
            }
        </Modal>
);
export default translate('logs')(LogCardModal);



// WEBPACK FOOTER //
// ./src/modules/logs/LogCardModal.js